export const initHeader = () => {
	addDropdownButtonEvents();
};

const addDropdownButtonEvents = () => {
	const menuItems = document.querySelectorAll("#navigation-modal .menu a");

	menuItems.forEach((item) => {
		const submenu = item.nextElementSibling;
		const dropdownButton = item.querySelector(".icon-caret-down");

		if (dropdownButton) {
			dropdownButton.addEventListener("click", (event) => {
				event.preventDefault();
				toggleSubMenu(item, submenu);
			});
		}

		function toggleSubMenu(item, submenu) {
			if (submenu) {
				submenu.classList.toggle("active");
				item.classList.toggle("active");
				let parent = item.parentElement;
				while (parent && parent.tagName !== "LI") {
					parent = parent.parentElement;
				}
				if (parent) {
					parent.classList.toggle("active");
				}
			}
		}
	});
};
